import { useState, useEffect } from 'react';

export const useFullscreen = elementRef => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = element => {
    const requestMethods = [
      'requestFullscreen',
      'mozRequestFullScreen',
      'webkitRequestFullscreen',
      'msRequestFullscreen'
    ];
    const method = requestMethods.find(m => element[m]);

    if (method) {
      element[method]();
    }
  };

  const exitFullscreen = () => {
    const exitMethods = [
      'exitFullscreen',
      'mozCancelFullScreen',
      'webkitExitFullscreen',
      'msExitFullscreen'
    ];
    const method = exitMethods.find(m => document[m]);

    if (method) {
      document[method]();
    }
  };

  const handleToggleFullscreen = () => {
    if (!isFullscreen) {
      enterFullscreen(elementRef.current);
    } else {
      exitFullscreen();
    }

    setIsFullscreen(!isFullscreen);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  return [isFullscreen, handleToggleFullscreen];
};

export default useFullscreen;
